export default {
  title: 'A HUB',
  tips: {
    enable: '开启后将在电脑桌面任务栏中显示实时电量',
    disable: '关闭后将在电脑桌面任务栏中默认 A HUB 图标',
  },
  resetSize: '窗口恢复默认大小',
  update: '立即更新',
  quit: '退出',
}
